import { MobileSelect } from '@/components/ui';
import {
  CUSTOMER_INVOICE_ATTACHMENT_TYPES,
  type CustomerInvoiceAttachmentType,
} from '../types';

interface AttachmentTypeSelectProps {
  value: CustomerInvoiceAttachmentType;
  onChange: (type: CustomerInvoiceAttachmentType) => void;
  disabled?: boolean;
  label?: string;
}

export function AttachmentTypeSelect({
  value,
  onChange,
  disabled = false,
  label = 'Document Type',
}: AttachmentTypeSelectProps) {
  return (
    <MobileSelect
      label={label}
      value={value}
      onChange={(val) => onChange(val as CustomerInvoiceAttachmentType)}
      disabled={disabled}
      options={CUSTOMER_INVOICE_ATTACHMENT_TYPES.map((t) => ({
        value: t.value,
        label: t.label,
      }))}
    />
  );
}
